module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/Rectangle1-62a4de2da8e60542b3ded3f15bae96aa.png";